import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import PropTypes from 'prop-types';
import t from 'format-message';
import { Flex } from '@instructure/ui-flex';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { View } from '@instructure/ui-view';
import OutcomeTags from "../OutcomeTags/index.js";
import OutcomeViewModal from "../OutcomeViewModal/index.js";
import SearchInput from "../SearchInput/index.js";
import SearchResults from "../SearchResults/index.js";
import { outcomeShape, launchContextsShape } from "../../store/shapes.js";
import NoResults from "../NoResults/index.js";
var OutcomePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(OutcomePicker, _React$Component);
  var _super = _createSuper(OutcomePicker);
  function OutcomePicker() {
    _classCallCheck(this, OutcomePicker);
    return _super.apply(this, arguments);
  }
  _createClass(OutcomePicker, [{
    key: "renderViewModal",
    value: function renderViewModal() {
      var _this$props = this.props,
        focusedOutcome = _this$props.focusedOutcome,
        setFocusedOutcome = _this$props.setFocusedOutcome,
        artifactTypeName = _this$props.artifactTypeName,
        displayMasteryDescription = _this$props.displayMasteryDescription,
        displayMasteryPercentText = _this$props.displayMasteryPercentText,
        scope = _this$props.scope;
      return focusedOutcome && /*#__PURE__*/React.createElement(OutcomeViewModal, {
        artifactTypeName: artifactTypeName,
        displayMasteryDescription: displayMasteryDescription,
        displayMasteryPercentText: displayMasteryPercentText,
        outcome: focusedOutcome,
        scope: scope,
        closeAlignment: function closeAlignment() {
          return setFocusedOutcome(null);
        },
        isOpen: true
      });
    }
  }, {
    key: "renderSearchMode",
    value: function renderSearchMode() {
      var _this$props2 = this.props,
        screenreaderNotification = _this$props2.screenreaderNotification,
        setSearchLoading = _this$props2.setSearchLoading,
        setSearchEntries = _this$props2.setSearchEntries,
        updateSearchPage = _this$props2.updateSearchPage,
        searchText = _this$props2.searchText,
        isSearchLoading = _this$props2.isSearchLoading,
        searchEntries = _this$props2.searchEntries,
        searchPage = _this$props2.searchPage,
        searchTotal = _this$props2.searchTotal,
        setActiveCollection = _this$props2.setActiveCollection,
        setFocusedOutcome = _this$props2.setFocusedOutcome,
        isOutcomeSelected = _this$props2.isOutcomeSelected,
        selectOutcomeIds = _this$props2.selectOutcomeIds,
        deselectOutcomeIds = _this$props2.deselectOutcomeIds;
      return /*#__PURE__*/React.createElement(SearchResults, {
        screenreaderNotification: screenreaderNotification,
        setSearchLoading: setSearchLoading,
        setSearchEntries: setSearchEntries,
        searchText: searchText,
        updateSearchPage: updateSearchPage,
        isSearchLoading: isSearchLoading,
        searchEntries: searchEntries,
        searchPage: searchPage,
        searchTotal: searchTotal,
        setActiveCollection: setActiveCollection,
        setFocusedOutcome: setFocusedOutcome,
        isOutcomeSelected: isOutcomeSelected,
        selectOutcomeIds: selectOutcomeIds,
        deselectOutcomeIds: deselectOutcomeIds,
        isPicker: true
      });
    }
  }, {
    key: "renderTreePickerMode",
    value: function renderTreePickerMode() {
      var _this$props3 = this.props,
        scope = _this$props3.scope,
        OutcomeTree = _this$props3.treeView;
      return /*#__PURE__*/React.createElement(OutcomeTree, {
        scope: scope
      });
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var _this$props4 = this.props,
        selectedOutcomes = _this$props4.selectedOutcomes,
        searchText = _this$props4.searchText,
        updateSearchText = _this$props4.updateSearchText,
        deselectOutcomeIds = _this$props4.deselectOutcomeIds;
      return /*#__PURE__*/React.createElement(View, {
        display: "block",
        borderWidth: "none none small none",
        padding: "small small medium small"
      }, /*#__PURE__*/React.createElement(View, {
        display: "block",
        padding: "none none small none"
      }, /*#__PURE__*/React.createElement(ScreenReaderContent, null, t('Selected outcomes:')), /*#__PURE__*/React.createElement(OutcomeTags, {
        outcomes: selectedOutcomes,
        emptyText: t('No Outcomes are currently selected'),
        deselectOutcomeIds: deselectOutcomeIds
      })), /*#__PURE__*/React.createElement(SearchInput, {
        onChange: function onChange(_, value) {
          return updateSearchText(value);
        },
        onClear: function onClear() {
          return updateSearchText('');
        },
        searchText: searchText
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        hasOutcomes = _this$props5.hasOutcomes,
        searchText = _this$props5.searchText,
        launchContexts = _this$props5.launchContexts;
      // If there are launch contexts, we cannot render this billboard because hasOutcomes is evaluated only for
      // the currently selected context. This would prevent users from selecting another context if the first
      // context failed to be retrieved OR had no outcomes.
      var hasMultipleContexts = (launchContexts === null || launchContexts === void 0 ? void 0 : launchContexts.length) > 1;
      if (!hasOutcomes && !hasMultipleContexts) {
        return /*#__PURE__*/React.createElement(NoResults, null);
      }
      return /*#__PURE__*/React.createElement(Flex, {
        direction: "column",
        height: "100%",
        width: "100%",
        padding: "x-small small 0 small"
      }, /*#__PURE__*/React.createElement(Flex.Item, null, this.renderHeader()), /*#__PURE__*/React.createElement(Flex.Item, {
        shouldGrow: true,
        maxHeight: "100%",
        size: "0"
      }, searchText ? this.renderSearchMode() : this.renderTreePickerMode(), this.renderViewModal()));
    }
  }]);
  OutcomePicker.displayName = "OutcomePicker";
  return OutcomePicker;
}(React.Component);
// eslint-disable-next-line no-undef
OutcomePicker.propTypes = {
  focusedOutcome: outcomeShape,
  setFocusedOutcome: PropTypes.func.isRequired,
  selectedOutcomes: PropTypes.arrayOf(outcomeShape).isRequired,
  isOutcomeSelected: PropTypes.func.isRequired,
  selectOutcomeIds: PropTypes.func.isRequired,
  deselectOutcomeIds: PropTypes.func.isRequired,
  setActiveCollection: PropTypes.func.isRequired,
  artifactTypeName: PropTypes.string,
  displayMasteryDescription: PropTypes.bool,
  displayMasteryPercentText: PropTypes.bool,
  searchText: PropTypes.string,
  setSearchLoading: PropTypes.func.isRequired,
  setSearchEntries: PropTypes.func.isRequired,
  isSearchLoading: PropTypes.bool.isRequired,
  searchEntries: PropTypes.array.isRequired,
  searchTotal: PropTypes.number,
  searchPage: PropTypes.number.isRequired,
  screenreaderNotification: PropTypes.func,
  updateSearchText: PropTypes.func.isRequired,
  updateSearchPage: PropTypes.func.isRequired,
  hasOutcomes: PropTypes.bool.isRequired,
  scope: PropTypes.string.isRequired,
  launchContexts: launchContextsShape,
  treeView: PropTypes.func.isRequired
};
OutcomePicker.defaultProps = {
  focusedOutcome: null,
  launchContexts: null,
  artifactTypeName: null,
  displayMasteryDescription: false,
  displayMasteryPercentText: false,
  searchText: '',
  screenreaderNotification: null,
  searchTotal: null
};
export default OutcomePicker;